<template>
    <div>
        <LoginFrame hide-contact>
            <h1>Organization Not Found</h1>
            <div style="margin-top: 8px">
                The organization you're trying to access is not available to your account.
            </div>
            <AppBtn style="margin-top: 20px" dense @click="onLogout">Log Out</AppBtn>
        </LoginFrame>
    </div>
</template>

<script>
import LoginFrame from "@/components/Login/LoginFrame.vue";
import { logout } from "@/services/userService";

export default {
    name: "OrganizationNotFound",
    components: { LoginFrame },
    methods: {
        onLogout() {
            logout(true);
        }
    }
}
</script>

<style scoped>

</style>
